import { render, staticRenderFns } from "./RegionSchools.vue?vue&type=template&id=8be3335a&scoped=true&"
import script from "./RegionSchools.vue?vue&type=script&lang=js&"
export * from "./RegionSchools.vue?vue&type=script&lang=js&"
import style0 from "./RegionSchools.vue?vue&type=style&index=0&id=8be3335a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be3335a",
  null
  
)

export default component.exports